import React from 'react';
import { motion } from 'framer-motion';
import robohr from '../assets/robohr.png';
import sih from '../assets/sih.png';

const ProjectCard = ({ project }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className="bg-gradient-to-br from-[#101C10]/40 to-[#112811]/40 backdrop-blur-sm 
                 rounded-2xl p-6 border border-[#2fe22f]/10 hover:border-[#2fe22f]/30 
                 transition-all duration-500 group"
    >
      {/* Project Image */}
      <div className="relative w-full h-48 mb-6 rounded-lg overflow-hidden">
        <img 
          src={project.image} 
          alt={project.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#101C10]/80 to-transparent" />
      </div>

      {/* Project Info */}
      <div className="space-y-4">
        <h3 className="text-2xl font-bold text-[#2fe22f]">{project.title}</h3>
        
        <p className="text-gray-300">{project.description}</p>

        {/* Tech Stack */}
        <div className="flex flex-wrap gap-2">
          {project.technologies.map((tech) => (
            <span 
              key={tech}
              className="px-3 py-1 text-sm bg-[#2fe22f]/10 text-[#2fe22f] rounded-full"
            >
              {tech}
            </span>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

const Projects = () => {
  const projects = [
    {
      title: "AI-Based Legal Document Assitent",
      description: "The AI-based Legal Document Assistant simplifies legal documents by generating concise summaries and enabling users to ask questions for better understanding. It features a legal chatbot capable of answering queries related to laws, including IPC sections and case-specific regulations. Built using Next.js, the project streamlines legal document analysis and enhances accessibility.",
      technologies: ["NextJS", "Firebase", "GPT 3.5", "MongoDB", "Tailwind", "Langchain","Pinecone","Beautiful Soup","Python","Razorpay"],
      live: "https://project-demo.com",
      github: "https://github.com/username/project",
      image: sih
    },
    {
      title: "Robo HR : Automating Resume Analysis with A",
      description: "The roboHR project is an AI-powered resume chatbot that parses resumes and allows HR professionals to ask specific questions based on the candidate's details. It streamlines the hiring process by providing quick, accurate responses about qualifications and experience. This innovative tool enhances efficiency and ensures better candidate evaluation.",
      technologies: ["Next.js", "Javascript", "Pinecone", "Langchain", "GPT 3.5","Tailwind"],
      live: "https://dashboard-demo.com",
      github: "https://github.com/username/dashboard",
      image: robohr
    }
  ];

  return (
    <section className="w-full font-lato min-h-screen bg-gradient-to-br from-[#101C10] to-[#112811] py-20" id='projects'>
      <motion.div 
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="container mx-auto px-6 max-w-6xl"
      >
        {/* Section Header */}
        <div className="flex items-center gap-4 mb-12">
          <motion.div 
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 200, delay: 0.2 }}
            className="w-12 h-1 bg-[#2fe22f]" 
          />
          <h2 className="text-4xl font-bold text-[#2fe22f]">Projects</h2>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project) => (
            <ProjectCard key={project.title} project={project} />
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Projects;